export default __webpack_public_path__ + "static/bg4-h-d2838707ec1fe78b07521135d863f11c.jpg";